import React, {
  useState,
  useEffect,
  forwardRef,
  useRef,
  useImperativeHandle,
} from 'react'
import styled from 'styled-components'

type MenuProps = {
  data: MenuEntry[]
  onClick: (partei: string, color: string) => void
  defaultValue?: string
  headerheight: number
  updatedPartyInView: string
}

// Define a type for individual TV Guide entries
type MenuEntry = {
  partei: string
  logo: string
  color: string
}

type StyledButtonProps = {
  active: boolean
  color: string
}

const partyLogos = require.context('../../assets/logos', true)

const MenuOnePager = forwardRef(
  (
    { data, onClick, defaultValue, headerheight, updatedPartyInView }: MenuProps,
    ref
  ) => {
    const defaultIndex = data.findIndex(
      (menuEntry) => menuEntry.partei === defaultValue
    )
    const [activeIndex, setActiveIndex] = useState(defaultIndex)
    const menuContainerRef = useRef<HTMLDivElement | null>(null)

    // Expose menuContainerRef to whoever consumes this Menu component via forwardRef
    useImperativeHandle(ref, () => menuContainerRef.current)

    useEffect(() => {
      const updatedIndex = data.findIndex(
        (menuEntry) => menuEntry.partei === updatedPartyInView
      )
      // Only update activeIndex if a match is found
      if(updatedIndex !== -1) {
        setActiveIndex(updatedIndex)
      }
    }, [updatedPartyInView, data]);

    return (
      <MenuContainer headerheight={headerheight} ref={menuContainerRef}>
        {data.map((menuEntry, index) => (
          <ButtonContainer key={index}>
            <StyledButton
              active={activeIndex === index}
              className={activeIndex === index ? 'active' : ''}
              color={menuEntry.color}
              onClick={() => {
                onClick(menuEntry.partei, menuEntry.color)
                // setActiveIndex(index)
              }}
            >
              <img
                src={partyLogos('./' + menuEntry.logo)}
                alt={menuEntry.partei}
                className='icon'
              />
            </StyledButton>
          </ButtonContainer>
        ))}
      </MenuContainer>
    )
  }
)

const MenuContainer = styled.div<{ headerheight?: number }>`
  display: flex;
  flex: 1 0 20%; /* explanation below */
  gap: 1px 1px;
  background-color: var(--gray-1);
  flex-wrap: wrap;
  position: sticky;
  top: ${({ headerheight }) => headerheight ?? 0}px;
  z-index: 6;
  /* box-shadow: 0 8px 35px -10px rgba(0, 0, 0, 0.4),
    0 15px 45px -17px rgba(0, 0, 0, 0.45); */
  box-shadow: 0px 15px 32px -15px rgba(0, 0, 0, 0.45);
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px 10px;
  justify-content: center;
  flex: 1 0 0.2%;
  @media screen and (max-width: 711px) {
    flex: 1 0 25%;
  }
`

const StyledButton = styled.button<StyledButtonProps>`
  border: none;
  cursor: pointer;
  min-height: 52px;
  width: 100%;

  background-color: ${(props) =>
    props.active ? props.color : 'var(--gray-2)'};
  img {
    &:hover:not(&.active) {
      transform: scale(1.1);
    }
  }
  img.icon {
    max-width: 66px;
    @media screen and (max-width: 711px) {
      max-width: 55px;
    }
    @media screen and (max-width: 375px) {
      max-width: 52px;
    }

  }
  @media screen and (max-width: 711px) {
    padding: 0 0em;
    min-height: 46px;
  }
`

export default MenuOnePager
